import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { headers } from '../../services/api';

import FormLogin from './FormLogin';
import FormRegister from './FormRegister';
import FormSendEmail from './FormSendEmail';
import FormResetPasswd from './FormResetPasswd';
import SendEmailCheck from './SendEmailCheck';
import TimeExpire from './TimeExpire';

import "./Form.css";

const SERVER = process.env.REACT_APP_API_URL;

const FormView = ({ searchForm }) => {
    const [users, setUsers] = useState([]);
    const [connections, setConnections] = useState([]);
    const [tokensExpire, setTokensExpire] = useState([]);

    const sendToken = new URLSearchParams(window.location.search).get("sendToken");

    const renderForm = () => {
        if (sendToken) {
            return <FormResetPasswd
                users={users}
                tokensExpire={tokensExpire}
                sendToken={sendToken}
            />
        } else {
            if (searchForm === "timeExpire") {
                return (
                    <TimeExpire />
                );
            }

            if (searchForm === "login") {
                return <FormLogin
                    users={users}
                    connections={connections}
                />
            }

            if (searchForm === "register") {
                return <FormRegister
                    users={users}
                />
            }

            if (searchForm === "sendemail") {
                return <FormSendEmail
                    users={users}
                />
            }

            if (searchForm === "resetpasswd") {
                return <SendEmailCheck />
            }
        }
    };

    const effectAsync = async () => {
        await fetch(`${SERVER}/user-search`, { headers }).then(response => {
            if (response.ok) {
                return response.json();
            }
        }).then(data => {
            setUsers(data.data.model);
        }).catch(error => {
            console.log(error);
        });

        await fetch(`${SERVER}/connection-search`, { headers }).then(response => {
            if (response.ok) {
                return response.json();
            }
        }).then(data => {
            setConnections(data.data.model);
        }).catch(error => {
            console.log(error);
        });

        await fetch(`${SERVER}/tokens-expire-search`, { headers }).then(response => {
            if (response.ok) {
                return response.json();
            }
        }).then(data => {
            setTokensExpire(data.data.model);
        }).catch(error => {
            console.log(error);
        });
    };

    useEffect(() => {
        effectAsync();
    }, []);

    return (
        <div className='container-fluid form_view_container'>
            {
                renderForm()
            }
        </div>
    );
};

const mapStoreToProps = (state) => {
    return {
        ...state
    };
};

export default connect(mapStoreToProps)(FormView);